// Third Party Libraries Imports
import toast from "react-hot-toast";
import { AxiosResponse } from "axios";
import { useDispatch } from "react-redux";

// Local Imports
import { LOADING } from "../../store/actions";
import instance from "../../store/axios";
import { SubscriptionListApiResponse } from "../login/types";

class AutoInvestService {
  private dispatch = useDispatch();

  public async getAutoInvestList(
    page,
    searchWord,
    sortField,
    sortOrder,
    isDeleted = false
  ): Promise<
    | {
        data: SubscriptionListApiResponse;
        message: string;
      }
    | undefined
  > {
    this.dispatch({ type: LOADING, payload: true });
    let query: string = `?page=${page}&pageSize=20`;

    if (searchWord) {
      query += `&search=${searchWord}`;
    }
    if (sortField) {
      query += `&sortField=${sortField}`;
    }
    if (sortOrder) {
      query += `&sortOrder=${sortOrder === "ascend" ? "asc" : "desc"}`;
    }

    if (isDeleted) {
      query += `&isDeleted=true`;
    }

    try {
      const response: AxiosResponse<{
        data: any;
        message: string;
      }> = await instance.get(`/${process.env.REACT_APP_ENDPOINT_VERSION}/subscription/auto-invest${query}`);
      return response.data;
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      localStorage.setItem("star_prev_url", "/auto-invest");
      return undefined;
    } finally {
      this.dispatch({ type: LOADING, payload: false });
    }
  }
}

export default AutoInvestService;
